<template>
  <div :class="'checkbox_container' + (disabled ? ' disabled' : '') + (isDisplay ? ' isDisplay' : '')">
    <div :class="'round'">
      <input v-if="disabled == true || isDisplay == true" type="checkbox" :checked="!!checked" :id="local_id" @change="onChange" disabled/>
      <input v-else type="checkbox" :checked="!!checked" :id="local_id" @change="onChange"/>
      <label :for="local_id"></label>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoundCheckbox",
  props: {
    isDisplay: Boolean,
    checked: Boolean,
    disabled: Boolean,
    source: String,
    id: String,
    update: Function
  },
  data() {
    return {
      local_id: ''
    }
  },
  methods: {
    onChange: function (comp) {
      if (typeof this.update != 'undefined') {
        this.update(this.source, comp.target.checked)
      }
    },
  },
  mounted() {
    if (typeof this.id != 'undefined') {
      this.local_id = this.id;
    } else {
      this.local_id = 'r_check_' + Math.random().toString()
    }
  }
}
</script>

<style scoped>
  .round {
    position: relative;
  }

  .checkbox_container .round label {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    height: 20px;
    left: 0;
    position: absolute;
    top: 0;
    width: 20px;
  }

  .checkbox_container:not(.disabled) .round label {
    cursor: pointer;
  }

  .checkbox_container.disabled .round label {
    background-color: #d3d3d3;
  }

  .round label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: "";
    height: 6px;
    left: 4px;
    opacity: 0;
    position: absolute;
    top: 5px;
    transform: rotate(-45deg);
    width: 12px;
  }

  .checkbox_container .round input[type="checkbox"] {
    visibility: hidden;
  }

  .checkbox_container:not(.disabled) .round input[type="checkbox"]:not(:checked) + label {
    background-color: #ffb81d;
    border-color: #ffb81d;
  }

  .checkbox_container:not(.disabled) .round input[type="checkbox"]:not(:checked) + label:before {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    border-left: none;
    content: "";
    height: 6px;
    opacity: 1;
    position: absolute;
    top: 5px;
    left: 4px;
    transform: rotate(45deg);
    width: 13px;
  }

  .checkbox_container:not(.disabled) .round input[type="checkbox"]:not(:checked) + label:after {
    width: 13px;
    border-left: none;
    opacity: 1;
    left: 1px;
    top: 5px;
  }

  .checkbox_container:not(.disabled) .round input[type="checkbox"]:checked + label {
    background-color: #66bb6a;
    border-color: #66bb6a;
  }

  .checkbox_container:not(.disabled) .round input[type="checkbox"]:checked + label:after {
    opacity: 1;
  }

  .checkbox_container.disabled .round label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    border-left: none;
    transform: none;
    opacity: 1;
    left: 3px;
    top: 4px;
  }

  .checkbox_container.disabled, .checkbox_container.isDisplay {
    pointer-events: none !important;
  }
</style>